/*
 * "Secondary" is the proper name for this button.
 * Exporting both names here for backwards compatibility.
 */
export { default as Secondary } from './secondary-button';
export { default as Outlined } from './secondary-button';
export { default as Primary } from './primary-button';
export { default as Alert } from './alert-button';
export { default as PrimaryWithIcon } from './primary-with-icon';
export { default as IconButton } from './icon-as-button';
export { default as Submit } from './submit';
